module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_videoBackGround.bcd13911.png";